class PromoBanner extends HTMLElement {
    connectedCallback() {
      this._slides = Array.from(this.querySelectorAll('.pb-slide'));
      if (!this._slides.length) return;
  
      const ENTER = 0.45;
      const EXIT  = 0.35;
      const speed = parseFloat(this.dataset.speed) || 3;
  
      // İlk slide'ı göster
      const first = this._slides[0];
      first.style.transition = 'none';
      first.style.transform  = 'translateY(0)';
      first.style.opacity    = '1';
  
      if (this._slides.length === 1) return;
  
      let current = 0;
  
      this._interval = setInterval(() => {
        const next = (current + 1) % this._slides.length;
  
        // Mevcut slide çıkış
        const cur = this._slides[current];
        cur.style.transition = `transform ${EXIT}s ease, opacity ${EXIT}s ease`;
        cur.style.transform  = 'translateY(-100%)';
        cur.style.opacity    = '0';
  
        // Yeni slide giriş
        const nxt = this._slides[next];
        nxt.style.transition = 'none';
        nxt.style.transform  = 'translateY(100%)';
        nxt.style.opacity    = '0';
        nxt.getBoundingClientRect(); // force reflow
        nxt.style.transition = `transform ${ENTER}s ease, opacity ${ENTER}s ease`;
        nxt.style.transform  = 'translateY(0)';
        nxt.style.opacity    = '1';
  
        current = next;
      }, speed * 1000);
    }
  
    disconnectedCallback() {
      clearInterval(this._interval);
    }
  }
  
  customElements.define('promo-banner', PromoBanner);